export const projectsData = {

    trackerProjects: [
        {
            title: "Digital marketing for react project",
            progress: 86,
            working_time: "08:30 - 09:30",
            logged_time: "00/h : 52/m : 34/s",
            remaing_time: "04:00 PM",
            icon: "feather-clock",
            brColor: "bg-success",
            comment: 32,
        },
        {
            title: "Search inspiration for project",
            progress: 46,
            working_time: "09:30 - 10:30",
            logged_time: "00/h : 50/m : 46/s",
            remaing_time: "05:00 PM",
            icon: "feather-clock",
            brColor: "bg-danger",
            comment: 45,
        },
        {
            title: "React admnin dashboard design",
            progress: 65,
            working_time: "11:00 - 12:30",
            logged_time: "00/h : 56/m : 47/s",
            remaing_time: "06:00 PM",
            icon: "feather-clock",
            brColor: "bg-primary",
            comment: 22,
        },
        {
            title: "Laravel ecommerce project tasks",
            progress: 75,
            working_time: "12:30 - 14:30",
            logged_time: "01/h : 48/m : 36/s",
            remaing_time: "07:00 PM",
            icon: "feather-clock",
            brColor: "bg-warning",
            comment: 36,
        },
        {
            title: "Search inspiration for project",
            progress: 80,
            working_time: "11:00 - 12:30",
            logged_time: "01/h : 22/m : 52/s",
            remaing_time: "08:00 PM",
            icon: "feather-clock",
            brColor: "bg-info",
            comment: 42,
        },
    ],

    runningProjects: [
        {
            id: 1,
            project_logo: "/images/brand/app-store.png",
            project_name: "Apps Development",
            project_category: "Applications",
            progress: 54,
            badge_color: "bg-soft-primary text-primary",
            progress_color: "bg-primary",
            status: "Inprogress",
            team_members: [
                {
                    id: 1,
                    user_name: "Janette Dalton",
                    user_img: "/images/avatar/2.png"
                },
                {
                    id: 2,
                    user_name: "Mikal Bon",
                    user_img: "/images/avatar/3.png"
                },
                {
                    id: 3,
                    user_name: "Socrates Itumay",
                    user_img: "/images/avatar/4.png"
                },
                {
                    id: 4,
                    user_name: "Jakson Jak",
                    user_img: "/images/avatar/6.png"
                },
                {
                    id: 5,
                    user_name: "Janette Dalton",
                    user_img: "/images/avatar/2.png"
                }
            ]
        },

        {
            id: 2,
            project_logo: "/images/brand/figma.png",
            project_name: "Dashboard Design",
            project_category: "App UI Kit",
            progress: 100,
            status: "Completed",
            badge_color: "bg-soft-success text-success",
            progress_color: "bg-success",
            team_members: [
                {
                    id: 1,
                    user_name: "Janette Dalton",
                    user_img: "/images/avatar/2.png"
                },
                {
                    id: 2,
                    user_name: "Mikal Bon",
                    user_img: "/images/avatar/3.png"
                },
                {
                    id: 3,
                    user_name: "Socrates Itumay",
                    user_img: "/images/avatar/4.png"
                },
                {
                    id: 4,
                    user_name: "Jakson Jak",
                    user_img: "/images/avatar/6.png"
                },
                {
                    id: 5,
                    user_name: "Janette Dalton",
                    user_img: "/images/avatar/2.png"
                }
            ]
        },
        {
            id: 3,
            project_logo: "/images/brand/facebook.png",
            project_name: "Facebook Marketing",
            project_category: "Marketing",
            progress: 90,
            status: "Inprogress",
            badge_color: "bg-soft-primary text-primary",
            progress_color: "bg-info",
            team_members: [
                {
                    id: 1,
                    user_name: "Janette Dalton",
                    user_img: "/images/avatar/2.png"
                },
                {
                    id: 2,
                    user_name: "Mikal Bon",
                    user_img: "/images/avatar/3.png"
                },
                {
                    id: 3,
                    user_name: "Socrates Itumay",
                    user_img: "/images/avatar/4.png"
                },
                {
                    id: 4,
                    user_name: "Jakson Jak",
                    user_img: "/images/avatar/6.png"
                },
                {
                    id: 5,
                    user_name: "Janette Dalton",
                    user_img: "/images/avatar/2.png"
                }
            ]
        },
        {
            id: 4,
            project_logo: "/images/brand/github.png",
            project_name: "React Dashboard Github",
            project_category: "Dashboard",
            progress: 37,
            status: "Inprogress",
            badge_color: "bg-soft-primary text-primary",
            progress_color: "bg-warning",
            team_members: [
                {
                    id: 1,
                    user_name: "Janette Dalton",
                    user_img: "/images/avatar/2.png"
                },
                {
                    id: 2,
                    user_name: "Mikal Bon",
                    user_img: "/images/avatar/3.png"
                },
                {
                    id: 3,
                    user_name: "Socrates Itumay",
                    user_img: "/images/avatar/4.png"
                },
                {
                    id: 4,
                    user_name: "Jakson Jak",
                    user_img: "/images/avatar/6.png"
                },
                {
                    id: 5,
                    user_name: "Janette Dalton",
                    user_img: "/images/avatar/2.png"
                }
            ]
        },
        {
            id: 5,
            project_logo: "/images/brand/paypal.png",
            project_name: "Paypal Payment Gateway",
            project_category: "Payment",
            progress: 29,
            status: "On Hold",
            badge_color: "bg-soft-warning text-warning",
            progress_color: "bg-danger",
            team_members: [
                {
                    id: 1,
                    user_name: "Janette Dalton",
                    user_img: "/images/avatar/2.png"
                },
                {
                    id: 2,
                    user_name: "Mikal Bon",
                    user_img: "/images/avatar/3.png"
                },
                {
                    id: 3,
                    user_name: "Socrates Itumay",
                    user_img: "/images/avatar/4.png"
                },
                {
                    id: 4,
                    user_name: "Jakson Jak",
                    user_img: "/images/avatar/6.png"
                },
                {
                    id: 5,
                    user_name: "Janette Dalton",
                    user_img: "/images/avatar/2.png"
                }
            ]
        },
    ],

    remaindersProjects: [
        {
            id: 1,
            project_name: "CRM Dashboard Redesign",
            project_info: `Management of project under "Duralux" brand`,
            status: "In Prograss",
            remaining_time: "",
            badgeColor:"primary"
        },

        {
            id: 2,
            project_name: "Duralux CRM Admin Project",
            project_info: `Duralux CRM Admin Project`,
            status: "Updading",
            remaining_time: "",
            badgeColor:"info"
        },
        {
            id: 3,
            project_name: "Website Redesign for Nike",
            project_info: `Website Redesign for Nike`,
            status: "Upcoming",
            remaining_time: "",
            badgeColor:"danger"

        },
        {
            id: 4,
            project_name: "Duralux CRM Dashbaord Project",
            project_info: `Duralux CRM Dashbaord Project`,
            status: "Submitted",
            remaining_time: "",
            badgeColor:"teal"
        },
        {
            id: 5,
            project_name: "Update User Flows with UX Feedback",
            project_info: `Update User Flows with UX Feedback`,
            status: "Working",
            remaining_time: "",
            badgeColor:"warning"
        },
    ],

    leadsProject: [
        {
            id: "#874965",
            title: "React admin dashboard design",
            email: "support@wrapcoders.com",
            phone: "+1 (375) 9874 663",
            address: "4295 Pheasant Ridge Road, Philadelphia, PA",
            revenue: "5,685",
            count: 5,
            label: "Follow Up",
            advance: "900",
            icon: "feather-user-plus",
            salesReps: [
                {
                    id: 1,
                    user_name: "Janette Dalton",
                    user_img: "/images/avatar/2.png"
                },
                {
                    id: 2,
                    user_name: "Mikal Bon",
                    user_img: "/images/avatar/3.png"
                },
                {
                    id: 3,
                    user_name: "Socrates Itumay",
                    user_img: "/images/avatar/4.png"
                },
                {
                    id: 4,
                    user_name: "Jakson Jak",
                    user_img: "/images/avatar/6.png"
                },
                {
                    id: 5,
                    user_name: "Wind Mind",
                    user_img: "/images/avatar/1.png"
                },
            ]
        },

        {
            id: "#963245",
            title: "React admin dashboard design",
            email: "support@wrapcoders.com",
            phone: "+1 (951) 6547 862",
            address: "1362 Emerson Road, Doyline, LA 71023",
            revenue: "6,500",
            count: 15,
            label: "Completed",
            advance: "700",
            icon: "feather-check-circle",
            salesReps: [
                {
                    id: 1,
                    user_name: "Janette Dalton",
                    user_img: "/images/avatar/2.png"
                },
                {
                    id: 2,
                    user_name: "Mikal Bon",
                    user_img: "/images/avatar/3.png"
                },
                {
                    id: 3,
                    user_name: "Socrates Itumay",
                    user_img: "/images/avatar/4.png"
                },
                {
                    id: 4,
                    user_name: "Jakson Jak",
                    user_img: "/images/avatar/6.png"
                },
                {
                    id: 5,
                    user_name: "Wind Mind",
                    user_img: "/images/avatar/1.png"
                },
            ]
        },
        {
            id: "#953684",
            title: "React admin dashboard design",
            email: "support@wrapcoders.com",
            phone: "+1 (951) 6547 862",
            address: "139 Ethels Lane, Okeechobee, FL 33472",
            revenue: "3,500",
            count: 2,
            label: "Upcomming",
            advance: "600",
            icon: "feather-eye",
            salesReps: [
                {
                    id: 1,
                    user_name: "Janette Dalton",
                    user_img: "/images/avatar/2.png"
                },
                {
                    id: 2,
                    user_name: "Mikal Bon",
                    user_img: "/images/avatar/3.png"
                },
                {
                    id: 3,
                    user_name: "Socrates Itumay",
                    user_img: "/images/avatar/4.png"
                },
                {
                    id: 4,
                    user_name: "Jakson Jak",
                    user_img: "/images/avatar/6.png"
                },
                {
                    id: 5,
                    user_name: "Wind Mind",
                    user_img: "/images/avatar/1.png"
                },
            ]
        },

    ],

    projectsStats: [
        {
            id: 1,
            project_logo: "/images/brand/app-store.png",
            project_name: "Apps Safety",
            project_owner: "Valentine Maton",
            budgets: "2,550",
            status: "In Progress",
            progress: 70,
            badgeColor: "primary"
        },
        {
            id: 2,
            project_logo: "/images/brand/github.png",
            project_name: "Github Update",
            project_owner: "Kenneth Hune",
            budgets: "1,200",
            status: "On Hold",
            progress: 60,
            badgeColor: "warning"
        },
        {
            id: 3,
            project_logo: "/images/brand/dropbox.png",
            project_name: "Dropbox Customization",
            project_owner: "Malanie Hanvey",
            budgets: "3,300",
            status: "Completed",
            progress: 100,
            badgeColor: "success"
        },
        {
            id: 4,
            project_logo: "/images/brand/facebook.png",
            project_name: "Facebook Marketing",
            project_owner: "Archie Cantones",
            budgets: "2,000",
            status: "In Progress",
            progress: 75,
            badgeColor: "primary"
        },
        {
            id: 5,
            project_logo: "/images/brand/figma.png",
            project_name: "Figma Dashboard",
            project_owner: " Valentine Maton",
            budgets: "2,000",
            status: "Upcomming",
            progress: 60,
            badgeColor: "teal"
        },
    ],

    timeSheetsProjects: [
        {
            progress: 40,
            footerLabelLeft: {
                title: "05/H : 33/M",
                description: "Billable Hours"
            },
            footerLabelRight: {
                title: "02/H : 14/M",
                description: "Unbillable Hours"
            },
            progressColor: "#ea4d4d",
            projectsList: [
                {
                    taskName: "React Apps",
                    completedTasks: "3",
                    totalTasks: "5",
                    time: "01/h: 34/m : 24/s",
                    bgColor: "bg-primary",
                    borderColor: "border-primary",
                },
                {
                    taskName: "Vuejs Apps",
                    completedTasks: "4",
                    totalTasks: "8",
                    time: "02/h: 26/m : 35/s",
                    bgColor: "bg-success",
                    borderColor: "border-success",
                },
                {
                    taskName: "CRM Admin",
                    completedTasks: "13",
                    totalTasks: "15",
                    time: "01/h: 34/m : 24/s",
                    bgColor: "bg-danger",
                    borderColor: "border-danger",
                },

            ]
        },
        {
            progress: 50,
            footerLabelLeft: {
                title: "15/30",
                description: "Tasks Completed"
            },
            footerLabelRight: {
                title: "00/50",
                description: "Tasks Upcomming"
            },
            progressColor: "#3454d1",
            projectsList: [
                {
                    taskName: "CRM Admin",
                    completedTasks: "13",
                    totalTasks: "15",
                    time: "01/h: 34/m : 24/s",
                    bgColor: "bg-danger",
                    borderColor: "border-danger",
                },
                {
                    taskName: "React Apps",
                    completedTasks: "3",
                    totalTasks: "5",
                    time: "01/h: 34/m : 24/s",
                    bgColor: "bg-primary",
                    borderColor: "border-primary",
                },
                {
                    taskName: "Vuejs Apps",
                    completedTasks: "4",
                    totalTasks: "8",
                    time: "02/h: 26/m : 35/s",
                    bgColor: "bg-success",
                    borderColor: "border-success",
                },
            ]
        },
        {
            progress: 65,
            footerLabelLeft: {
                title: "13/20",
                description: "Projects Completed"
            },
            footerLabelRight: {
                title: "00/25",
                description: "Projects Upcomming"
            },
            progressColor: "#ffa21d",
            projectsList: [
                {
                    taskName: "Vuejs Apps",
                    completedTasks: "4",
                    totalTasks: "8",
                    time: "02/h: 26/m : 35/s",
                    bgColor: "bg-success",
                    borderColor: "border-success",
                },
                {
                    taskName: "React Apps",
                    completedTasks: "3",
                    totalTasks: "5",
                    time: "01/h: 34/m : 24/s",
                    bgColor: "bg-primary",
                    borderColor: "border-primary",
                },
                {
                    taskName: "CRM Admin",
                    completedTasks: "13",
                    totalTasks: "15",
                    time: "01/h: 34/m : 24/s",
                    bgColor: "bg-danger",
                    borderColor: "border-danger",
                },

            ]
        },
    ]

}

